import { get } from 'lodash';
import React, { FC } from 'react';
import { useApplication } from '../../../../context/ApplicationContext';
import { APIS } from '../../../../lib/constants/apis';

import Schema from '../../../../lib/paths/antrag_FULL_Paths.json';
import BreadCrumbAbschlussbericht from './BreadCrumbAbschlussbericht';
import BreadCrumbAntrag from './BreadCrumbAntrag';
import BreadCrumbMittelAbruf from './BreadCrumbMittelAbruf';
import BreadcrumbSkizze from './BreadcrumbSkizze';
import BreadCrumbVerwendungsnachweis from './BreadCrumbVerwendungsnachweis';
import BreadCrumbZwischenbericht from './BreadCrumbZwischenbericht';
const P = Schema.attributes;

const ApplicationBreadcrumbs: FC<{ api: string }> = ({ api }) => {
	const { application } = useApplication();

	const RenderContent = () => {
		switch (api) {
			case APIS.Antrag:
				if (get(application, P.Allgemein_Typ.path) === 'Antrag') {
					return <BreadCrumbAntrag />;
				} else {
					return <BreadcrumbSkizze />;
				}
			case APIS.Mittelabruf:
				return <BreadCrumbMittelAbruf />;
			case APIS.Verwendungsnachweis:
				return <BreadCrumbVerwendungsnachweis />;
			case APIS.Zwischenbericht:
				return <BreadCrumbZwischenbericht />;
			case APIS.Abschlussbericht:
				return <BreadCrumbAbschlussbericht />;
			default:
				return <></>;
		}
	};

	return <RenderContent />;
};

export default ApplicationBreadcrumbs;
